<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 228.69 222.54"
    style="enable-background: new 0 0 228.69 222.54"
    fill="currentColor"
    class=""
    :class="{
      [`fill-${color} h-${height} w-${width}`]: true,
    }"
    xml:space="preserve"
  >
    <g>
      <path
        class="st0"
        d="M170.61,222.54c-18.01,0-35.29-7.61-53.17-15.49c-1.49-0.66-3-1.32-4.52-1.99
		c-33.39-14.62-65.66-45.03-90.86-85.63c-0.43-0.69-0.73-1.18-0.9-1.44c-6.68-9.62-22.07-34.76-21.1-60.66
		C1.07,29.8,15.4,15.63,21.52,9.57c0.38-0.37,0.72-0.72,1.04-1.03C29.3,1.7,42.08-1.58,52.93,0.74c8.73,1.87,15.05,6.96,17.8,14.34
		c1.35,3.62,3.32,8.98,5.4,14.64c3.69,10.02,8.73,23.75,9.5,25.44c2.55,5.58,2.51,10.86-0.13,15.69c-0.22,0.39-0.4,0.74-0.58,1.08
		l-0.25,0.46c-2.1,3.92-5.48,7.55-8.74,11.05c-2.5,2.68-7.11,7.64-7.27,9.58c3.5,6.53,13.06,22.99,27.17,36.54
		c8.63,8.3,17.63,15,27.5,20.5c0.92,0.51,1.95,1.12,3.04,1.76c10.75,6.34,13,5.88,13.47,5.38c4.2-4.48,13.96-15.23,17.23-19.74
		c7.22-10.01,16.19-6.38,20.5-4.63c6,2.44,36.51,19.05,36.81,19.21c0,0,0,0,0,0c0.98,0.53,1.89,1.02,2.74,1.47
		c4.51,2.39,8.07,4.28,10.1,7.96c3.33,6.05,0.57,20.7-3.72,31.42c-3.07,7.66-10.33,13.77-15.89,17.54
		C194.71,219.22,182.5,222.54,170.61,222.54z M45.64,13.99c-5.13,0-10.44,1.67-13.12,4.38c-0.35,0.35-0.73,0.73-1.15,1.15
		c-5.36,5.3-16.51,16.34-17.33,38.34c-0.83,22.3,14.03,45.54,18.6,52.13c0.26,0.37,0.69,1.05,1.31,2.05
		c23.73,38.21,53.77,66.69,84.59,80.19c1.53,0.67,3.05,1.34,4.55,2c29.41,12.95,50.65,22.31,76.66,4.64
		c5.49-3.73,9.41-7.8,10.76-11.17c3.68-9.2,4.34-16.71,4.19-19.49c-0.93-0.62-2.67-1.55-4.12-2.32c-0.9-0.48-1.87-0.99-2.9-1.55l0,0
		c-8.13-4.45-31.32-16.88-35.37-18.53c-1.51-0.61-2.56-0.97-3.1-1.06c-0.16,0.15-0.42,0.43-0.78,0.92
		c-4.72,6.52-18.24,20.98-18.38,21.13c-9.24,9.79-22.72,1.83-30.78-2.92c-0.98-0.58-1.9-1.12-2.74-1.58
		c-10.94-6.09-20.88-13.5-30.4-22.64c-15.6-14.99-26.07-33.04-29.84-40.1c-5.27-9.88,3.21-19,9.4-25.65
		c2.66-2.86,5.41-5.81,6.67-8.15l0.24-0.44c0.21-0.39,0.42-0.79,0.65-1.21c0.3-0.54,0.59-1.09-0.34-3.14
		c-0.88-1.94-4.33-11.27-9.9-26.42c-2.07-5.63-4.04-10.97-5.38-14.58c-1.31-3.52-4.86-4.95-7.62-5.54
		C48.61,14.13,47.13,13.99,45.64,13.99z M215.22,168.63L215.22,168.63L215.22,168.63z M214.59,167.37L214.59,167.37L214.59,167.37z
		 M169.37,144.61L169.37,144.61L169.37,144.61z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
  },
};
</script>
